var _defs, _defs2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    className: "css-1j8o68f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1590"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient1595"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop1596",
    stopColor: "#6d7cff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop1597",
    stopColor: "#ff51ff",
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1591",
    featurekey: "symbolFeature-0",
    transform: "matrix(0.07741935483870968,0,0,0.07741935483870968,-8.438709677419356,-2.206451612903226)",
    fill: "url(#SvgjsLinearGradient1595)"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", {
    xmlns: "http://www.w3.org/2000/svg"
  })), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M371 443c43,0 76,-38 94,-79 9,-1 19,-8 24,-20 8,-15 4,-32 -7,-38 -1,0 -2,0 -3,-1 2,-34 -6,-68 -28,-92 -3,-4 -10,-6 -14,-11 -26,-39 -86,-22 -119,-32 -25,-7 -28,5 -19,36 0,0 -8,8 -12,12 -18,23 -25,55 -23,87 -1,1 -2,1 -3,1 -11,6 -15,23 -7,38 5,12 15,19 24,20 18,41 51,79 93,79zm199 -186l70 0 0 38c0,21 -70,21 -70,0l0 -38zm102 -170l20 -20c5,-4 11,2 7,7l-20 20c-5,4 -11,-2 -7,-7zm-195 69l28 0c7,0 7,10 0,10l-28 0c-7,0 -7,-10 0,-10zm228 0l28 0c7,0 7,10 0,10l-28 0c-7,0 -7,-10 0,-10zm-187 -89l20 20c4,5 -2,11 -7,7l-20 -20c-4,-5 2,-11 7,-7zm92 -34l0 28c0,7 -10,7 -10,0l0 -28c0,-6 10,-6 10,0zm31 214c0,3 -2,5 -5,5l-62 0c-3,0 -5,-2 -5,-5 0,-31 -44,-51 -44,-90 0,-37 36,-80 80,-80 44,0 80,43 80,80 0,39 -44,59 -44,90zm-91 -75c2,6 -7,8 -8,2 -9,-34 11,-70 46,-80 6,-1 8,7 2,9 -30,8 -47,39 -40,69zm-188 331l-15 113 -84 -142c-106,59 -154,-5 -154,144l0 122c94,19 129,79 262,79 133,0 168,-60 263,-79l0 -122c0,-149 -48,-85 -154,-144l-84 142 -15 -113c20,-15 14,-13 5,-39l-29 0c-9,26 -15,24 5,39z",
    style: {
      fill: "url(#SvgjsLinearGradient1595)"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoImg);
export default __webpack_public_path__ + "static/media/logo-img.d58c0f081ae459ce986ae13c139638f4.svg";
export { ForwardRef as ReactComponent };